import { swarmLayers } from '@lbs/swarm-client';

import { getBetSelectionListSwarmRequest } from '@app/dev/helpers/terminalRequests/events';
import { fetchRequest, swarmRequest } from '@common/helpers/util/requestMiddleware';

export const getCasinoBetsInfo = async (config, transIds) => fetchRequest(
  config.casino.middlewareUrl,
  `api/tickets/GetTicketInfoByTransactionIdsTokenAuth?token=${config.casino.middlewareAuthToken}`,
  'POST',
  { body: transIds },
);

export const getBetSelectionList = async (ticket) => {
  const eventIds = ticket.dataFromSwarm.selection_list.map((item) => item.selection_id);
  const matchIds = ticket.dataFromSwarm.selection_list.map((item) => item.match_id);

  const fullSelectionsTree = (await swarmRequest(getBetSelectionListSwarmRequest(eventIds, matchIds))).data;

  return swarmLayers(fullSelectionsTree);
};
